import { useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from "../../../../Models/Utilisateur";
import { useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import { useState } from "react";
import { Button, Form, Tabs, Space, Spin, Table } from 'antd';
import type { TabsProps } from 'antd';
import { Box, Typography } from '@mui/material';
import SweetAlert from "sweetalert2";
import InputForm from "../../../InputT";
import SearchModal from "../../../SearchModal";
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import Tab2 from './ta1';
import SearInputG from "../../../SearchInput"
import axios from 'axios';
//pour le tableau
import DataType from "../../../../Functions/Traitement/DataPeriodMbloquer";
import { ColumnGroupType, ColumnsType } from 'antd/es/table';
import Data from '../../../../Data/Data.json'
import { Crypter } from "../../../../Functions/Security/Crypter";
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import formatDate from '../../../../Functions/Traitement/fomatDate';


const ValidBlocage = () => {

    const [donnees, setData] = useState<DataType[]>([]);

    //column du tableau 
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro dossier',
            dataIndex: 'REFMARQ',

        },
        {
            title: 'Numéro compte',
            dataIndex: 'NUMCPT',
        },
        {
            title: 'Intitulé ',
            dataIndex: 'NOMCPT',
        },
        {
            title: 'Montant',
            dataIndex: 'MONTPR',
        },
        {
            title: 'Crée le',
            dataIndex: 'DATCRE',
        },
        {
            title: 'Date fin ',
            dataIndex: 'DATEFM',
        }
    ];


    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const [loading, setLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [form] = Form.useForm();
    const [Valid, setValid] = useState(true);
    const [Actual, setActual] = useState(false)
    const authHeader = useAuthHeader()
    const [state, setstate] = useState(false)
    const [sbmit, setSbmit] = useState("")

    // handle
    function HandleActualiser() {
        localStorage.clear();
        Consultableau();
        form.resetFields();
        setSelectedRowKeys([]);
    }

    // gestion du tab 
    const items: TabsProps['items'] = [
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Validation bloquage
                </span>
            ),
            children: <Tab2 form={form} />, //form={form}
        },

    ];

    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);
        sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].REFMARQ))
        consult();
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });
    }



    //function pour lire loadData

    setTimeout(() => {
        if (donnees.length == 0) {
            if (!state) {
                setstate(true)
                Consultableau()
            }

        }
        try {
            let reset = localStorage.getItem(Data.LocalVariable.reset)
            if (reset == "1") {
                setData([])
            }
        }
        catch (error) {
            console.log(error)
        }
    }, 0.1);


    //  function consult
    function consult() {
        let data = Crypter.encrypt((Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + ""));
        if (data.length != 0) {
            setLoading(true)
            form.resetFields()
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.ReadMontantBloquer,
                headers: {
                    'CypherREFMARQ': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };
            axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data));
                        let MontantBloquer = res.Result.Table[0]
                        if (res.StatutCode == 200) {
                            form.setFieldsValue(MontantBloquer);
                            console.log(MontantBloquer)
                            form.setFieldValue("DATEFM", ReformatDate(MontantBloquer.DATEFM));
                        }
                        else {
                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                        }
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                });
        }

    }

    // function Onfinish
    const onFinish = () => {
        let Numcrd = (form.getFieldValue("REFMARQ"));
        let data2 = Crypter.encrypt((Perss.coduti));
        let Data3 = Crypter.encrypt(formatDate(Perss.datjour));
        let data4 = Crypter.encrypt(Perss.codage);


        if (Numcrd == null) {
            SweetAlert.fire({ title: "Warning", text: "Svp selectionné un Gel", icon: "warning" })
        } else {

            if (sbmit == "valid") {



                SweetAlert.fire({
                    title: "VALIDATION GEL",
                    text: "Voulez-vous valider le Gel " + Numcrd + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValideMontantBloquer,
                            headers: {
                                'CypherREFMARQ': Crypter.encrypt((Numcrd)),
                                'Cypherutival': data2,
                                'CypherDatval': Data3,
                                'Cyphercodeage':data4,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };
                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    let code = res.Result
                                    //console.log('code'+code);

                                    if (code == 'GelValide') {
                                        SweetAlert.fire({ title: " ", text: "Gel N°:" + code + " déja Valide", icon: "warning" })
                                    } else if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "Validation impossible: le valideur doit etre différent de celui qui a initié le blocage", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Gel validé N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        HandleActualiser()
                                    }

                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })

            }
            if (sbmit == "rejet") {



                SweetAlert.fire({
                    title: "Rejet GEL",
                    text: "Voulez-vous Rejeter le Gel " + Numcrd + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.RejetMbloque,
                            headers: {
                                'CypherREFMARQ': Crypter.encrypt((Numcrd)),
                                'Cypherutival': data2,
                                'CypherDatval': Data3,
                                'Cyphercodeage':data4,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };
                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    let code = res.Result
                                    //console.log('code'+code);

                                    if (code == 'GelValide') {
                                        SweetAlert.fire({ title: " ", text: "Gel N°:" + code + " déja Valide", icon: "warning" })
                                    } else if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "Validation impossible: le Rejeteur doit etre différent de celui qui a initié le blocage", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Gel Rejeter N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        HandleActualiser()
                                    }

                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })

            }
        }
    };

    // control du forms 
    const onFinishFailed = (errorInfo: any) => {
        setLoading(true);
        setLoading(false);
    };


    ///function pour remplir les données du tableau 
    function Consultableau() {
        let a = Perss.codage;
        let b = '1'
        if (!loading) {
            setLoading(true)
            form.resetFields()
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AllReadMontantBloquer,
                headers: {
                    'Cyphercodage': Crypter.encrypt(a),
                    'Cyphertrie': Crypter.encrypt(b),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json',
                },
            };

            //MAPPING DANS LE TABLEAU
            let dat: DataType[] = [];

            axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {

                        let datas = response.data.Result;
                        console.log(datas)
                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                REFMARQ: val.REFMARQ,
                                codage: val.codage,
                                NUMCPT: val.NUMCPT,
                                NOMCPT: val.NOMCPT,
                                MONTPR: val.MONTPR,
                                DISPON: val.DISPON,
                                DATCRE: val.DATCRE,
                                DATEFM: val.DATEFM,
                                MOTIFM: val.MOTIFM,
                            })
                        })
                        setData((dat))

                    } else {
                        SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                });
        }
    }


    const verifSubmit = () => {
        if (!isSubmit) {
            SweetAlert.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };



    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b>  {window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { onFinish();setSbmit("valid") }} type="ghost" htmlType="submit" block>
                                    valider
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { onFinish();setSbmit("rejet") }} type="ghost" htmlType="submit" block>
                                    Rejeter
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { HandleActualiser() }} type="ghost" block  >
                                    Actualiser
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div  >
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            <div className='tabItem' >
                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"100%"} position={"absolute"}  >
                                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                                            <Box fontStyle="inherit" className='border-left '>
                                                <legend> Mise en place d'un montant bloqué </legend>
                                                <fieldset className="bordure1" style={{ marginTop: -10 }}>
                                                <Box style={{ display: 'flex' }}>
                                                    <Box>
                                                        <Box style={{ marginTop: -5 }}>
                                                            <SearInputG notRequired dissabledCode={true} width={4} Titre="Recherche" label="Réference" name="REFMARQ" Taille1={'100%'} Taille2={0} form={form}  />
                                                        </Box>
                                                        <Box style={{ marginTop: -10 }}>
                                                            <SearchModal width={4} Titre="Recherche" label="Id Client" name="NUMCLI"  Taille1={150} Taille2={350} form={form}  />
                                                        </Box>
                                                        <Box style={{ marginTop: -10 }}>
                                                            <SearchModal  Titre="Recherche" label="N° de compte" name="NUMCPT"  Taille1={250} Taille2={250} form={form}  />
                                                        </Box>
                                                    </Box>
                                                    <Box >
                                                        <Box style={{ marginTop: -5, width: '100%' }}>
                                                            <InputForm label="Date Fin Blocage" width={11} name="DATEFM" type="date" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm width={11} label="Mntant Bloquage" type="number" name="MONTPR" />
                                                        </Box>
                                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                                            <InputForm disabled={true} width={11} label="Mntant Disponible" type="number" name="DISPON" />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </fieldset>
                                            <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                                <Box style={{ marginTop: -5, width: '100%' }}>
                                                    <InputForm width={3} label="Motif Bloquage" type="texte" name="MOTIFM" />
                                                </Box>
                                            </fieldset>

                                            </Box>
                                            <Box fontStyle="inherit" className='border-left ' style={{ marginTop: -10 }}>
                                                <legend> Listes des Montants Bloqués en attentes  </legend>
                                                <Spin style={{ marginTop: -10 }} spinning={loading}>
                                                    <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} columns={columns} style={{ textAlign: "center", width: '100%', marginTop: -10 }} scroll={{ y: 400, x: 400 }} size='small' pagination={false} />
                                                </Spin>
                                            </Box>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );


}

export default ValidBlocage;